module.exports = __webpack_public_path__ + "media/images/common/visit_reserve/hokepon-logo-bc9e53fbd983d3b51d25f8e8b3b43a64.png";